export const emailJsPublicKey = process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY;
export const emailJsPrivateKey = process.env.REACT_APP_EMAIL_JS_PRIVATE_KEY;
export const emailJsServiceId = process.env.REACT_APP_EMAIL_JS_SERVICE_ID;
export const emailJsContactUsFormTemplateId =
  process.env.REACT_APP_EMAIL_JS_CONTACT_US_FORM_TEMPLATE_ID;
export const emailJsFirstPurchaseFormTemplateId =
  process.env.REACT_APP_EMAIL_JS_FIRST_PURCHASE_FORM_TEMPLATE_ID;
